var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name === 'create-kokuban')?_c('CreKokuban',{attrs:{"constructionList":_vm.constructionList},on:{"get-list":_vm.getConstructionList}}):_vm._e(),_c('router-view',{attrs:{"constructionList":_vm.constructionList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }